import { render, staticRenderFns } from "./ClassifcationList.vue?vue&type=template&id=d5ad2550&"
import script from "./ClassifcationList.vue?vue&type=script&lang=ts&"
export * from "./ClassifcationList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports